import {
    AUTH_LOGIN,
    STORE_TOKEN,
    REGISTER_USER,
    AUTH_LOGOUT,
    GET_USERS,
    STORE_USERS,
    UPDATE_USER_INFO,
    UPDATE_USER_ID,
    GET_EMPLOYEES,
    STORE_EMPLOYEES, UPDATE_SELECTED_COMPANY, GET_ONLINE_EMPLOYEES, STORE_ONLINE_EMPLOYEES,
} from '../../constants/auth';

export const authLogin = (username, password, history) => ({
    type: AUTH_LOGIN,
    username,
    password,
    history,
});

export const storeToken = (token, userInfo ) => ({
    type: STORE_TOKEN,
    token,
    userInfo,
    isAuthenticated: true
});

export const registerUser = (newUser,callback) => ({
    type: REGISTER_USER,
    newUser,
    callback
});

export const authLogout = (history) => ({
    type: AUTH_LOGOUT,
    history,
});

export const getUsers = () => ({
    type: GET_USERS
})

export const storeUsers = (users) => ({
    type: STORE_USERS,
    users
})

export const updateUserInfo = (userInfo) => ({
    type: UPDATE_USER_INFO,
    userInfo
})

export const updateSelectedCompany = (selectedCompany,selectedLocationName) => ({
    type: UPDATE_SELECTED_COMPANY,
    selectedCompany,
    selectedLocationName
})

export const updateSelectedUserId = (user) => ({
    type: UPDATE_USER_ID,
    user
})

export const getEmployees = (data) => ({
    type: GET_EMPLOYEES,
    data
})

export const storeEmployees = (employees) => ({
    type: STORE_EMPLOYEES,
    employees
})


export const getOnlineEmployees = (data) => ({
    type: GET_ONLINE_EMPLOYEES,
    data
})

export const storeOnlineEmployees = (employees) => ({
    type: STORE_ONLINE_EMPLOYEES,
    employees
})